module.exports = __webpack_public_path__ + "static/img/shz.4b74cce6.png";